// NOTE: These match the server's enum values and SHOULD NOT be changed, unless done on both side simultaneously!
export const ALL_ACTIVE_CONTACT_TYPES = ['admins', 'helpers', 'friends', 'requests_received', 'requests_sent'];
export const ACTIVE_CONTACT_EXPANDABLE_SECTION_TYPES = {
    friends: 'friends-online',
    admins: 'admins-online',
    helpers: 'helpers-online',
    requests_received: 'requests-received',
    requests_sent: 'requests-sent'
};
